export default __webpack_public_path__ + "static/media/newspaper.333f0c38.png";